module.exports = __webpack_public_path__ + "static/media/Ananya Kumar.fcc5fd4a.jpeg";